module.exports = __webpack_public_path__ + "static/media/15 Hooks.403e9350.jpg";